import React, { useEffect, useState } from 'react'
import styles from './new.module.css'
import { Col, Row, Form } from 'react-bootstrap'
import TopNavbar from '../../../Component/TopMenu/TopNavbar'
import NavbarSection from '../../../Component/NavbarSection/NavbarSection'
import { Helmet } from 'react-helmet'
import Cookies from 'js-cookie'
import { BASE_URL } from '../../../Apis/BaseUrl'
import axios from 'axios'
import { toast } from 'react-toastify'
import { fileChecker } from '../../../Component/FileChecker/fileChecker'
import ToasterUpdate from '../../../Component/Toaster/ToasterUpdate'
import { useNavigate } from 'react-router-dom'
import FileLabel from '../../../Component/FileLabel/FileLabel'
import AsyncSelect from 'react-select/async'
// import AsyncSelectData from '../../../Component/AsyncSelectData/AsyncSelectData'

const AddCategories = () => {
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [parent, setParent] = useState('')
    const [name, setName] = useState('')
    const [selectedImage, setSelectedImage] = useState('');
    const [categoryData, setCategoryData] = useState({})
    const [catType, setCatType] = useState("interior")
    const[commission, setCommission] = useState(0)
    const[affiliate_commission, setAffiliateCommission] = useState(0)

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        setSelectedImage(file);
    };
    const navigate = useNavigate()

    let profileTokenJson = Cookies.get("v&b_token");
    let profileToken = JSON.parse(profileTokenJson);
    // console.log(profileToken.token)
    let token = profileToken.token;

    const getData = async () => {

        let register = `${BASE_URL}/category?limit=10&page=1`

        // console.log(register)
        let res = await axios.get(register, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            }
        })
        // console.log(res.data.data.docs[0])
        let resData = res?.data?.data?.docs?.map(item => ({
            value: item._id,
            label: item.name
        }));
        setData(resData)
        // setPageInfo({ ...res.data.data, docs: null })
    }

    useEffect(() => {
        getData()
    }, [])

    
    const getCatData = async (query = '') => {
        try {
            let register = `${BASE_URL}/category?limit=200&page=1&search=${query}`

            let res = await axios.get(register, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            })
            return res.data.data.docs.map((element) => ({ label: element.name, value: element._id }))
        }
        catch (error) {
            console.error('Error while uploading data:', error);

            toast.error({
                render: error.message,
                type: 'error',
                isLoading: false,
                autoClose: 1500
            });
        }
    }

    const handleCatFeild = value => {
        setCategoryData(value)
    }


    const selectProps = {
        placeholder: "Select Category",
        data: data,
        dataHandler: getData,
        valueHandler: setCategoryData,
    }

    const handleAdd = async (e) => {
        e.preventDefault()

        const formData = new FormData();
        formData.append('name', name);
        formData.append('commission', commission);
        formData.append('affiliate_commission', affiliate_commission);
        formData.append('type', catType);
        // formData.append('category', priority);
        if (categoryData?.value) {
            formData.append('parent', categoryData.value);
        } else {
            formData.append('parent', '');
        }

        let checkFile = fileChecker(selectedImage)
        if (!checkFile.value) {
            toast.error(checkFile.message)
            return
        }
        formData.append('banner', selectedImage);

        console.log(selectedImage)
        // console.log(categoryData.label, name)
        let register = `${BASE_URL}/category`
        const myToast = toast.loading('Please Wait...')
        setLoading(true)
        try {

            let res = await axios.post(register, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token} `,
                },
            })
            console.log(res)
            if (!res.data.success) {
                ToasterUpdate(myToast, res.data.message, "error")
            }
            ToasterUpdate(myToast, res.data.message, "success")
            // getData()
            navigate('/product/categories')
        } catch (error) {
            // console.log(error)
            ToasterUpdate(myToast, error.message, "error")
        }
        finally {
            setLoading(false)
            setSelectedImage(null)
            setName("")
            setParent('')
            setAffiliateCommission('')
        }
    };

    return (
        <React.Fragment>
            <Helmet>
                <title>Add Categories</title>
            </Helmet>
            <TopNavbar />
            <NavbarSection />
            <Row className={styles.categories}>
                <Col className='mx-auto' md={10}>
                    <div className={styles.product_info}>
                        <div className={styles.product_info_section}>
                            <h6>Category Information</h6>
                        </div>
                        <div className={styles.main_section}>
                            <Form>
                                <div className={styles.input_container}>
                                    <label for="inputField"> Name:</label>
                                    <Form.Control type="text" placeholder="category name..." value={name} onChange={(e) => setName(e.target.value)} />

                                </div>
                                <div className={styles.input_container_brand}>
                                    <label for="inputField_2">Parent Category:</label>
                                    {/* <AsyncSelectData cls={styles.height} {...selectProps} /> */}
                                    <AsyncSelect className={styles.height} onInputChange={(text) => getCatData(text)} cacheOptions getOptionValue={e => e.value} loadOptions={getCatData} value={categoryData} defaultOptions onChange={handleCatFeild} />

                                </div>
                                <div className={`${styles.input_container_unit}`}>
                                    <label style={{ fontSize: "14px", fontWeight: "500" }} >Category Type*</label>

                                    <select className="form-select" aria-label="Default select example" value={catType} onChange={(e) => setCatType(e.target.value)} required>
                                        <option value="interior" selected>Interior</option>
                                        <option value="exterior">Exterior</option>
                                        <option value="both">Both</option>

                                    </select>
                                </div>
                                <div className={`${styles.input_container} mt-4`}>
                                    <label for="inputField"> Commission(in %):</label>
                                    <Form.Control type="number" placeholder="enter commission" value={commission} onChange={(e) => setCommission(e.target.value)} />

                                </div>
                                <div className={`${styles.input_container} mt-4`}>
                                    <label for="inputField">Affiliate Commission:</label>
                                    <Form.Control type="number" placeholder="enter commission" value={affiliate_commission} onChange={(e) => setAffiliateCommission(e.target.value)} />

                                </div>
                                <div className={`${styles.input_container_unit}`}>
                                    <label style={{ fontSize: "14px", fontWeight: "500" }} >Banner (277*158px) :</label>

                                    <FileLabel id="attachment" file_label={styles.file_label} setter={handleImageChange}

                                        placeholder='upload logo' />
                                </div>
                               

                                <div className={styles.save_btn}>
                                    <button onClick={handleAdd} disabled={loading}>Save</button>
                                </div>

                            </Form>
                        </div>
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default AddCategories